import { combineReducers } from 'redux';

import AccessPolicyTypes from './types';

export const accessPolicyReducer = combineReducers({
  accounts: AccessPolicyTypes.accounts.getReducer(),
  permissions: AccessPolicyTypes.permissions.getReducer(),
  modules: AccessPolicyTypes.modules.getReducer(),
  groups: AccessPolicyTypes.groups.getReducer(),
  users: AccessPolicyTypes.users.getReducer(),
});
